export const flightClass = {
  economy: "ECONOMY",
  economyStandard: "ECONOMY",
  economyPremium: "ECONOMY PREMIUM",
  business: "BUSINESS",
  first: "FIRST",
};
